<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
		<path d="M9 7H15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
		<path d="M15 17V14" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
		<path d="M15 11H15.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
		></path>
		<path d="M12 11H12.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
		></path>
		<path d="M9 11H9.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
		<path d="M9 14H9.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
		<path d="M12 14H12.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
		></path>
		<path d="M12 17H12.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
		></path>
		<path d="M9 17H9.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
		<path
			d="M5 7C5 5.11438 5 4.17157 5.58579 3.58579C6.17157 3 7.11438 3 9 3H12H15C16.8856 3 17.8284 3 18.4142 3.58579C19 4.17157 19 5.11438 19 7V12V17C19 18.8856 19 19.8284 18.4142 20.4142C17.8284 21 16.8856 21 15 21H12H9C7.11438 21 6.17157 21 5.58579 20.4142C5 19.8284 5 18.8856 5 17V12V7Z"
			stroke-linejoin="round"
		></path>
	</svg>
</div>
